import { shopPrefix } from '../../config';
import { http } from '../axios';
import { convertUsageConditionToUsageConditionDto } from '../../shared/utils/convertLineItemKey';
import { UpdateProductOptions } from '../../store/api';

const url = `${shopPrefix}/v2/shoppingcart/products/:productId/remove`;

export const removeProductFromCart = async ({ id, subscriptionPeriodType, price }: UpdateProductOptions) => {
    await http.put(
        url,
        { usageCondition: convertUsageConditionToUsageConditionDto(price), subscriptionPeriodType },
        { pathParams: { productId: id } }
    );
};
